import React from "react";
import { Header, Segment, List, Message } from "semantic-ui-react";
import CustomJsonView from "../../custom-json-view";

const createJson = {
  files: {
    enabled: true,
  },
  metadata: {
    titles: [
      {
        titleLanguage: "eng",
        titleText: "This is test title",
      },
    ],
  },
  parent: {
    communities: {
      default: "elter",
    },
  },
  externalWorkflow: {
    defaultWorkflowTemplateId: "basic-ingest",
  },
};

const Create = () => {
  return (
    <Segment padded>
      <Header as="h2" dividing>
        Create a New Record
      </Header>
      <Message info>
        <Message.Header>Overview</Message.Header>
        <p>
          This endpoint allows you to create a new record in the draft state.
          While the record is in the draft state, you can modify it (add
          metadata or files). Records must be created under a specified model,
          which represents a type of record (e.g., dataset, software, etc.) and
          its metadata.
        </p>
        <p>
          The record must be created by a user with a specified role in the
          community assigned in the request body. For the external-datasets
          model, only users with the administrator role can create records.
        </p>
      </Message>
      <Header as="h3">Request Details</Header>
      <Segment>
        <Header as="h4">Body Parameters</Header>
        <List bulleted>
          <List.Item>
            <strong>externalWorkflow.defaultWorkflowTemplateId</strong> -
            Defines quality checks ID for the record.
          </List.Item>
          <List.Item>
            <strong>metadata</strong> - Any default metadata during the creation
            of the record.
          </List.Item>
          <List.Item>
            <strong>parent.communities.default</strong> - Defines the community
            where the record will be created.
          </List.Item>
          <List.Item>
            <strong>files.enabled</strong> - Specifies if files are enabled for
            the record.
          </List.Item>
        </List>
      </Segment>
      <Segment>
        <Header as="h4">Endpoint</Header>
        <Message>
          <Message.Content>
            <strong>POST</strong> /api/&lt;model_name&gt;/ <br />
            <strong>Headers:</strong> <br />
            Content-Type: application/json <br />
            Authorization: Bearer &lt;authToken&gt;
          </Message.Content>
        </Message>
      </Segment>
      <Header as="h3">Example Request Body</Header>
      <CustomJsonView src={createJson} />
      <Header as="h3">Response</Header>
      <Message warning>
        <Message.Header>TODO</Message.Header>
        <p>Response details will be added here.</p>
      </Message>
    </Segment>
  );
};

export default Create;
